import { api } from "./client.js";

export interface MeUser {
  id: string;
  name: string;
  handle: string | null;
  primary_email: string;
  default_visibility: string;
}

export const authApi = {
  me: () => api.get<{ user: MeUser }>("/api/auth/me"),
  // Passwordless email sign-in. Request always succeeds (no account enumeration);
  // a link is only emailed to eligible addresses.
  requestEmailLink: (email: string, inviteCode?: string) =>
    api.post<{ ok: boolean }>(
      "/api/auth/email/request",
      inviteCode ? { email, inviteCode } : { email },
    ),
  verifyEmailLink: (token: string) =>
    api.post<{ user: MeUser; isNew: boolean }>("/api/auth/email/verify", { token }),
  logout: () => api.post<{ ok: boolean }>("/api/auth/logout"),
};
